export default __webpack_public_path__ + "static/media/switch.6c60081c.svg";